import React, { useEffect, useState } from "react";
import { ProtectedLayout } from "../../layouts";
import { ImageInput, Input, Loader, Titlebar } from "../../components";
import { useFormik } from "formik";
import { newsSchema } from "../../utils/schemas";
import { Button } from "react-bootstrap";
import ReactQuill from "react-quill";
import { ASSETS_BASE_URL, NewsService } from "../../service";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

export default function EditNews() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const onSubmit = async (values) => {
    try {
      let form = new FormData();
      if (values.image instanceof File) {
        form.append("file", values.image);
        await NewsService.updateImage(id, form);
      }
      Object.keys(values).forEach((key) => {
        if (key !== "image") {
          form.append(key, values[key]);
        }
      });
      await NewsService.update(id, form);
      toast.success("news successfully updated!");
      navigate("/news");
    } catch (error) {
      toast.error("Error while storing!");
    }
  };
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      heading: "",
      description: "",
      image: null,
    },
    validationSchema: newsSchema,
    onSubmit: onSubmit,
  });

  useEffect(() => {
    const fetchNews = async () => {
      try {
        console.log("Fetching news for ID:", id); // Check the ID
        let response = await NewsService.getById(id);
        console.log("API Response:", response); // Check the entire response object
        let result = response.data.data || response.data; // Adjust based on the response structure
        console.log("News data:", result);
  
        // Set the form values
        setFieldValue("heading", result.heading);
        setFieldValue("description", result.description);
        setFieldValue(
          "image",
          result.image === "avatar.jpg"
            ? "/images/avatar.jpg"
            : ASSETS_BASE_URL + result.image
        );
      } catch (error) {
        console.error("Error fetching the news:", error.response || error.message || error); // Log detailed error information
        toast.error("Error while fetching the news!");
      } finally {
        setLoading(false);
      }
    };
  
    fetchNews();
  }, [id, setFieldValue]);
  
  // useEffect(() => {
  //   const fetchNews = async () => {
  //     try {
  //       let response = await NewsService.getById(id);
  //       console.log("response", response)
  //       console.log("console data", response);
  //       let result = response.data.data;
  //       console.log("result data", result);

  //       setFieldValue("title", result.title);
  //       console.log("result data", result);
  //       setFieldValue("description", result.description);
  //       setFieldValue(
  //         "image",
  //         result.image === "avatar.jpg"
  //           ? "/images/avatar.jpg"
  //           : ASSETS_BASE_URL + result.image
  //       );
  //     } catch (error) {
  //       toast.error("Error while fetching the news!");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchNews();
  // }, [id, setFieldValue]); // Include 'id' and 'setFieldValue' in the dependency array

  return (
    <ProtectedLayout>
      <Titlebar heading="Edit News" />
      {loading ? (
        <div className="d-flex justify-content-center align-items-center py-3">
          <Loader />
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <ImageInput
            label="Cover Photo"
            name="image"
            value={values.image}
            errors={errors.image}
            touched={touched.image}
            setFieldValue={setFieldValue}
          />
          <Input
            label="Heading"
            placeholder="Enter heading"
            name="heading"
            value={values.heading}
            errors={errors.heading}
            touched={touched.heading}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <div className="mb-3">
            <div className="bg-white">
              <ReactQuill
                theme="snow"
                value={values.description}
                onChange={(value) => setFieldValue("description", value)}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, 3, 4, 5, 6, 0] }],
                    ["bold", "italic", "underline"],
                    ["image", "code-block"],
                    [{ header: 1 }, { header: 2 }], // Additional header styles
                    [{ list: "ordered" }, { list: "bullet" }], // Ordered and unordered lists
                    ["link", "blockquote", "code"], // Link, blockquote, and code
                    [{ align: [] }], // Text alignment
                    [{ indent: "-1" }, { indent: "+1" }], // Indentation
                    ["table"], // Table module
                  ],
                }}
                placeholder="Compose an epic..."
              />
            </div>
            {errors.description && touched.description && (
              <p className="text-danger mt-1 mb-0">{errors.description}</p>
            )}
          </div>
          <div className="text-end">
            <Button type="submit">Save</Button>
          </div>
        </form>
      )}
    </ProtectedLayout>
  );
}
